import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { useHistory, useLocation, useParams } from 'react-router';
import React, { createElement, useContext, useEffect, useState } from 'react';
import BreadCrumbs from '@componentsV2/BreadCrumbs';
import {
  acDeleteDocument,
  acDeletePropertyDocumentFolder,
  acSetDocuments,
  acSetDocumentSearchText,
  acSetFetchingDocumentsError,
  acSetIsCreatingDocumentFolder,
  acSetPropertyDocumentFolders,
  acSetPropertyDocumentFoldersToRender,
  acSetPropertyFoldersBreadCrumbs,
  acSetSelectedPropertyFolderId,
} from '../../../../store/actions/documents';

import {
  acSetPersonalDocuments,
  acSetFetchingPersonalDocumentsError,
  acSetPersonalDocumentFolders,
  acSetPersonalDocumentFoldersToRender,
  acSetSelectedPersonalFolderId,
  acSetPersonalFoldersBreadCrumbs,
} from '../../../../store/actions/personalDocuments';

import {
  sGetDocuments,
  sGetDocumentSearchText,
  sGetFetchingDocumentsError,
  sGetIsCreatingDocumentFolder,
  sGetPropertyDocumentFolders,
  sGetPropertyDocumentFoldersToRender,
  sGetPropertyFoldersBreadCrumbs,
} from '../../../../store/reducers/documents';
import {
  sGetFetchingPersonalDocumentFolders,
  sGetPersonalDocumentFolders,
  sGetPersonalDocuments,
  sGetPersonalFoldersBreadCrumbs,
} from '../../../../store/reducers/personalDocuments';
import { sGetUser } from '../../../../store/reducers/auth';
import styles from './style';
import ChapterList from './ChapterList';
import ChapterTable from './ChapterTable';
import Box from '../../../../components/atomic/Box';
import Divider from '../../../../components/Divider';
import useDesktop from '../../../../hooks/useDesktop';
import Page from '../../../../components/layouts/WithHeader';
import useFetchEffect from '../../../../hooks/useFetchEffect';
import EmptyMessage from '../../../../components/EmptyMessage';
import IconButton from '../../../../components/atomic/IconButton';
import ErrorContainer from '../../../../components/ErrorContainer';
import { FileUploadContext } from '../../../../contexts/fileUpload';
import { parseQuery, stringifyQuery } from '../../../../utils/routes';
import { acDetachDocumentFromRooms } from '../../../../store/actions/rooms';
import { acDetachDocumentFromEvents } from '../../../../store/actions/events';
import ChapterMode from '../../../../assets/icons/DocumentChapters/ChapterMode';
import {
  fetchDocuments as apiFetchDocuments,
  fetchPropertyFolders,
} from '../../../../api/properties';
import {
  fetchPersonalDocuments as apiFetchPersonalDocuments,
  fetchPersonalFolders as apiFetchPersonalFolders,
} from '../../../../api/propertyowners';
import DocumentMode from '../../../../assets/icons/DocumentChapters/DocumentMode';
import Features from '../../../../modules/Features';
import { features } from '../../../../structure/features';
import Grid from '../../../../components/atomic/Grid';
import {
  getDocumentList,
  getDocumentTable,
} from '../../../../utils/DocumentTable';
import TabContext from '../../../../components/atomic/TabContext';
import TabPanel from '../../../../components/atomic/TabPanel';
import MobileDocumentSearch from './MobileDocumentSearch';
import useAddNewDocumentMenu from '../../../../hooks/useAddNewDocumentMenu';
import Typography from '../../../../components/atomic/Typography';
import useDebounce from '../../../../hooks/useDebounce';

const Documents = ({
  classes,
  documents,
  propertyDocumentFolders,
  propertyDocumentFoldersToRender,
  propertyFoldersBreadCrumbs,
  personalDocuments,
  personalDocumentFolders,
  personalFoldersBreadCrumbs,
  setDocuments,
  setPropertyFoldersBreadCrumbs,
  setPropertyDocumentFolders,
  setPropertyDocumentFoldersToRender,
  setPersonalDocuments,
  setPersonalFoldersBreadCrumbs,
  setPersonalDocumentFolders,
  setPersonalDocumentFoldersToRender,
  fetchingError,
  deleteDocument,
  setFetchingError,
  setPersonalDocumentFetchingError,
  detachDocumentFromRooms,
  detachDocumentFromEvents,
  searchText,
  setSearchText,
  isCreatingDocumentFolder,
  setIsCreatingDocumentFolder,
  activeUser,
  deletePropertyDocumentFolder,
  setSelectedPersonalFolderId,
  setSelectedPropertyFolderId,
}) => {
  const history = useHistory();
  const isDesktop = useDesktop();
  const { search, pathname } = useLocation();
  const parsedQuery = parseQuery(search);
  const [allDocumentsLoaded, setAllDocumentsLoaded] = useState(false);
  const [currentDocFolderId, setCurrentDocFolderId] = useState(null);
  const [personalDocumentsToRender, setPersonalDocumentsToRender] = useState(
    []
  );
  const [propertyDocumentsToRender, setPropertyDocumentsToRender] = useState(
    []
  );
  const [headerHeight, setHeaderHeight] = useState(0);
  const [stickyFiltersHeight, setStickyFiltersHeight] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const { boligmappaNumber } = useParams();
  const [isBoligmappaPlusUser, setIsBoligmappaPlusUser] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [fetchingFolders, setFetchingFolders] = useState(false);
  const [fetchingPersonalDocuments, setFetchingPersonalDocuments] =
    useState(false);
  const [fetchingPersonalDocumentFolders, setFetchingPersonalDocumentFolders] =
    useState(false);

  const { setIsAddingNewDoc, isCreatingName, setIsCreatingName } =
    useAddNewDocumentMenu({
      currentDocFolderId,
      breadCrumbs: propertyFoldersBreadCrumbs,
      boligmappaNumber,
    });

  useEffect(() => {
    setIsCreatingName(isCreatingDocumentFolder);
  }, [isCreatingDocumentFolder]);

  useEffect(() => {
    setIsCreatingDocumentFolder(isCreatingName);
  }, [isCreatingName]);

  const missingDocumentFeature = features.filter(
    (feature) => feature.code === 'MISSING_DOCUMENTS'
  );

  const { ids: documentIds, chaptersMode } = parsedQuery || {};

  const {
    onFileUploadClick,
    directoryId,
    setDirectoryId,
    directoryTree,
    setDirectoryTree,
  } = useContext(FileUploadContext);

  useEffect(() => {
    setIsBoligmappaPlusUser(activeUser?.isSubscribeToBoligmappaPlus);
  }, [activeUser]);

  const updatePropertyDocsAndFoldersToRender = (folderId) => {
    setCurrentDocFolderId(folderId);
    let foldersToRender = propertyDocumentFolders;
    propertyFoldersBreadCrumbs.forEach((breadcrumb) => {
      foldersToRender = foldersToRender.find(
        (el) => el.id === breadcrumb.id
      ).directories;
    });
    setPropertyDocumentFoldersToRender(foldersToRender);
    setSelectedPropertyFolderId(folderId);
    setPropertyDocumentsToRender(
      documents && documents.filter((doc) => doc.directoryId === folderId)
    );
  };

  const onPropertyFolderChange = (id) => {
    updatePropertyDocsAndFoldersToRender(id);
    const currentFolder = propertyDocumentFoldersToRender.find(
      (folder) => folder.id === id
    );
    setPropertyFoldersBreadCrumbs([
      ...propertyFoldersBreadCrumbs,
      currentFolder,
    ]);
  };

  const launchDocsAndFoldersState = ({ folders, docs }) => {
    if (folders) {
      setPropertyDocumentFolders(folders);
      setPropertyDocumentFoldersToRender(folders);
      setSelectedPropertyFolderId(null);
    }
    if (docs) {
      const docsToRender = docs.filter((el) => el.directoryId === null);
      setDocuments(docs);
      setPropertyDocumentsToRender(docsToRender);
    }
  };

  const launchPersonalDocsAndFoldersState = ({ folders, docs }) => {
    if (folders) {
      setPersonalDocumentFolders(folders);
      setPersonalDocumentFoldersToRender(folders);
      setSelectedPersonalFolderId(null);
    }
    if (docs) {
      const docsToRender = docs.filter((el) => el.directoryId === null);
      setPersonalDocuments(docs);
      setPersonalDocumentsToRender(docsToRender);
    }
  };

  useFetchEffect({
    dependencies: [boligmappaNumber],
    conditionFunction: () => documents?.length === 0,
    setFetchingFunction: (data) => setFetching(data),
    onSuccess: (data) => launchDocsAndFoldersState({ docs: data }),
    onError: (error) => setFetchingError(error),
    apiFetchFunction: () =>
      apiFetchDocuments(boligmappaNumber, { includeTaggedInfo: true }),
  });

  useFetchEffect({
    dependencies: [boligmappaNumber],
    conditionFunction: () => propertyDocumentFolders?.length === 0,
    setFetchingFunction: (data) => setFetchingFolders(data),
    onSuccess: (data) =>
      launchDocsAndFoldersState({ folders: data.directories.reverse() }),
    onError: (error) => setFetchingError(error),
    apiFetchFunction: () => fetchPropertyFolders(boligmappaNumber),
  });

  useFetchEffect({
    dependencies: [boligmappaNumber],
    conditionFunction: () => personalDocuments?.length === 0,
    setFetchingFunction: (data) => setFetchingPersonalDocuments(data),
    onSuccess: (data) =>
      launchPersonalDocsAndFoldersState({ docs: data.documents }),
    onError: (error) => setPersonalDocumentFetchingError(error),
    apiFetchFunction: () => apiFetchPersonalDocuments(),
  });

  useFetchEffect({
    dependencies: [boligmappaNumber],
    conditionFunction: () => personalDocumentFolders?.length === 0,
    setFetchingFunction: (data) => setFetchingPersonalDocumentFolders(data),
    onSuccess: (data) =>
      launchPersonalDocsAndFoldersState({
        folders: data.directories.reverse(),
      }),
    onError: (error) => setPersonalDocumentFetchingError(error),
    apiFetchFunction: () => apiFetchPersonalFolders(),
  });

  useEffect(() => {
    if (
      !fetching &&
      !fetchingFolders &&
      !fetchingPersonalDocuments &&
      !fetchingPersonalDocumentFolders
    ) {
      setAllDocumentsLoaded(true);
    } else {
      setAllDocumentsLoaded(false);
    }
  }, [
    fetching,
    fetchingFolders,
    fetchingPersonalDocuments,
    fetchingPersonalDocumentFolders,
  ]);

  useEffect(() => {
    if (documents) {
      setPropertyDocumentsToRender(
        documents.filter((doc) => doc.directoryId === currentDocFolderId)
      );
    }
  }, [documents]);

  useEffect(() => {
    setPersonalDocumentsToRender(
      personalDocuments.filter((doc) => doc.directoryId === currentDocFolderId)
    );
  }, [personalDocuments]);

  useEffect(() => {
    updatePropertyDocsAndFoldersToRender(
      propertyFoldersBreadCrumbs[propertyFoldersBreadCrumbs.length - 1]?.id ||
        null
    );
  }, [propertyDocumentFolders, propertyFoldersBreadCrumbs]);

  useEffect(() => {
    if (history.action !== 'POP') {
      setPersonalFoldersBreadCrumbs([]);
      setPropertyFoldersBreadCrumbs([]);
    }
  }, [history]);

  const documentDebouncedSearch = useDebounce(searchText, 500);

  const [searchQuery, setSearchQuery] = useState(searchText);

  const [showEmptyListMessage, setShowEmptyListMessage] = useState(
    !fetching && documents && documents.length === 0
  );

  useEffect(() => {
    setShowEmptyListMessage(
      !fetching && propertyDocumentsToRender.length === 0
    );
  }, [personalDocumentsToRender, propertyDocumentsToRender]);

  useEffect(() => {
    setSearchQuery(documentDebouncedSearch);
  }, [documentDebouncedSearch]);

  useEffect(() => {
    setSearchQuery('');
    setSearchText('');
  }, [propertyFoldersBreadCrumbs, personalFoldersBreadCrumbs]);

  const toggleChaptersMode = () => {
    history.push({
      pathname,
      search: stringifyQuery({ ...parsedQuery, chaptersMode: !chaptersMode }),
    });
  };

  const onSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const onDocumentDeleted = (document) => {
    detachDocumentFromRooms(document);
    detachDocumentFromEvents(document);
    deleteDocument(document);
  };

  const onFolderDelete = (folders) => {
    const folderIds = folders.map((el) => el.id);
    const deleteDocumentAction = deleteDocument;
    const documentsToCheck = documents;
    const deletedDocs = documentsToCheck.filter((doc) =>
      folderIds.includes(doc.directoryId)
    );
    if ((deletedDocs || []).length > 0) {
      deletedDocs?.forEach((doc) => {
        deleteDocumentAction(doc);
      });
    }
    const deleteDocumentFolderAction = deletePropertyDocumentFolder;
    if (folders.length > 0) {
      folders.forEach((folder) => {
        deleteDocumentFolderAction(folder);
      });
    }
  };

  const handleDocumentUpload = () => {
    onFileUploadClick({
      query: {
        bulkUploadMode: true,
        source: isDesktop ? 'table' : 'listView',
        newUpload: true,
        personalDocument: false,
      },
    });
    setIsAddingNewDoc(false);
  };

  const renderMobileBreadCrumbs = () => {
    const selectedBreadCrumbs = propertyFoldersBreadCrumbs;
    return selectedBreadCrumbs.length > 0 ? (
      <BreadCrumbs
        breadCrumbs={selectedBreadCrumbs}
        breadCrumbsNames={selectedBreadCrumbs.map((el) => el.name)}
        setBreadCrumbs={setPropertyFoldersBreadCrumbs}
        onlyBack
        pathClassName={classes.breadcrumbs}
      />
    ) : (
      <Typography
        className={isDesktop ? classes.headerTitle : classes.headerTitleMobile}
      >
        Alle dokumenter
      </Typography>
    );
  };

  const changeBreadCrumb = (index) =>
    setPropertyFoldersBreadCrumbs(
      propertyFoldersBreadCrumbs.slice(0, index + 1)
    );

  const rootBreadCrumb = () => setPropertyFoldersBreadCrumbs([]);

  const renderHeaderBreadCrumbs = () => {
    const breadCrumbsNames = propertyFoldersBreadCrumbs
      .map((el) => el.name)
      .slice(0, -1);
    return (
      <div className="flex overflow-hidden">
        <>
          <div>
            <button
              type="button"
              className={classes.breadCrumbButton}
              onClick={rootBreadCrumb}
            >
              <p style={{ color: '#717171' }}>Alle dokumenter</p>
            </button>
          </div>
          {breadCrumbsNames.length > 0 && (
            <div style={{ color: '#717171' }}>/</div>
          )}
        </>
        {breadCrumbsNames.map((el, index) => (
          <>
            {index + 1 !== breadCrumbsNames.lenght && (
              <div>
                <button
                  type="button"
                  className={classes.breadCrumbButton}
                  onClick={() => changeBreadCrumb(index)}
                >
                  <p style={{ color: '#717171' }}>{el}</p>
                </button>
              </div>
            )}
            {index + 1 !== breadCrumbsNames.length && (
              <div style={{ color: '#717171' }}>/</div>
            )}
          </>
        ))}
      </div>
    );
  };

  const mobileHeaderSearch = () => (
    <MobileDocumentSearch
      fullWidth
      value={searchText}
      onChange={onSearchChange}
      onClearSearch={() => setSearchText('')}
      placeholder="Søk i dokumenter"
      isSearching
      setIsSearching={setIsSearching}
    />
  );

  const renderTable = () => {
    if (chaptersMode) {
      return createElement(isDesktop ? ChapterTable : ChapterList, {
        documents,
        searchQuery,
        fetchingDocuments: fetching,
        fetchingDocumentsError: fetchingError,
      });
    }
    return createElement(isDesktop ? getDocumentTable() : getDocumentList(), {
      fetching: !allDocumentsLoaded,
      documents: propertyDocumentsToRender,
      onFolderChange: onPropertyFolderChange,
      documentFolders: propertyDocumentFoldersToRender,
      directoryId: directoryId || currentDocFolderId,
      setDirectoryId,
      directoryTree,
      setDirectoryTree,
      documentIds,
      searchQuery,
      fetchingError,
      onDocumentDeleted,
      isFromPersonal: false,
      headerHeight,
      setStickyFiltersHeight,
      showRoomsColumn: true,
      showEventsColumn: true,
      showBulkSelectionOptions: true,
      isPersonalDocuments: false,
      isBoligmappaPlusUser: isBoligmappaPlusUser === true,
      onFolderDelete,
    });
  };

  const chaptersModeToggleButton = (
    <IconButton size="medium" onClick={toggleChaptersMode}>
      {createElement(chaptersMode ? DocumentMode : ChapterMode, {
        className: classes.chaptersToggleButtonMobile,
      })}
    </IconButton>
  );

  const renderHeaderContextButtons = () =>
    !isDesktop ? chaptersModeToggleButton : null;

  const missingDocumentSection = (
    <Grid container justifyContent="center">
      <Grid item xs={8} lg={4}>
        <Box mx={3} mt={8}>
          <Features singleFeature={missingDocumentFeature} />
        </Box>
      </Grid>
    </Grid>
  );
  return (
    <Page
      topLevelLayout
      document
      noPadding
      maxWidth={false}
      headerTitle={renderMobileBreadCrumbs()}
      headerContextButtons={renderHeaderContextButtons()}
      headerSearch={mobileHeaderSearch()}
      isSearching={isSearching}
      setHeaderHeight={setHeaderHeight}
    >
      {fetchingError ? (
        <ErrorContainer
          paddingTop={isDesktop}
          errorResponse={fetchingError}
          style={{ paddingTop: isDesktop ? undefined : '15%' }}
        />
      ) : (
        <div
          className={classes.mobileDocListContent}
          style={{ marginTop: stickyFiltersHeight }}
        >
          <div className={classes.tabContent}>
            <TabContext value="1">
              <div>
                {propertyFoldersBreadCrumbs.length > 0 ? (
                  <Box flex="none">
                    {renderHeaderBreadCrumbs()}
                    <Typography
                      className={
                        isDesktop
                          ? classes.headerTitle
                          : classes.headerTitleMobile
                      }
                    >
                      {propertyFoldersBreadCrumbs.slice(-1)[0]?.name}
                    </Typography>
                  </Box>
                ) : (
                  <Typography
                    className={
                      isDesktop
                        ? classes.headerTitle
                        : classes.headerTitleMobile
                    }
                  >
                    Alle dokumenter
                  </Typography>
                )}
              </div>
              <TabPanel value="1">
                <Box mt={1}>{renderTable()}</Box>
              </TabPanel>
              <TabPanel value="2">
                <Box mt={1}>{renderTable()}</Box>
              </TabPanel>
            </TabContext>
          </div>
          {showEmptyListMessage && (
            <EmptyMessage
              shiftMarginTopBy={121}
              onLinkClick={handleDocumentUpload}
              className={classes.emptyMessage}
              buttonText="Legg til nytt"
              additionalContent={
                <Box className={classes.dividerContent}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} lg={4}>
                      <Box mt={6}>
                        <Divider>ELLER</Divider>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              }
            >
              Du har ikke lastet opp noen dokumenter.
            </EmptyMessage>
          )}
          {missingDocumentSection}
        </div>
      )}
    </Page>
  );
};

const mapStateToProps = (state) => ({
  documents: sGetDocuments(state),
  fetchingError: sGetFetchingDocumentsError(state),
  searchText: sGetDocumentSearchText(state),
  personalDocuments: sGetPersonalDocuments(state),
  propertyDocumentFolders: sGetPropertyDocumentFolders(state),
  personalDocumentFolders: sGetPersonalDocumentFolders(state),
  propertyDocumentFoldersToRender: sGetPropertyDocumentFoldersToRender(state),
  propertyFoldersBreadCrumbs: sGetPropertyFoldersBreadCrumbs(state),
  personalFoldersBreadCrumbs: sGetPersonalFoldersBreadCrumbs(state),
  personalDocumentFoldersFetching: sGetFetchingPersonalDocumentFolders(state),
  activeUser: sGetUser(state),
  isCreatingDocumentFolder: sGetIsCreatingDocumentFolder(state),
});

const mapDispatchToProps = (dispatch) => ({
  detachDocumentFromRooms: (document) =>
    dispatch(acDetachDocumentFromRooms(document)),
  detachDocumentFromEvents: (document) =>
    dispatch(acDetachDocumentFromEvents(document)),
  setFetchingError: (fetchingError) =>
    dispatch(acSetFetchingDocumentsError(fetchingError)),
  setPersonalDocumentFetchingError: (fetchingError) =>
    dispatch(acSetFetchingPersonalDocumentsError(fetchingError)),
  setDocuments: (documents) => dispatch(acSetDocuments(documents)),
  setPersonalDocuments: (documents) =>
    dispatch(acSetPersonalDocuments(documents)),
  setPersonalDocumentFolders: (folders) =>
    dispatch(acSetPersonalDocumentFolders(folders)),
  setPropertyDocumentFolders: (folders) =>
    dispatch(acSetPropertyDocumentFolders(folders)),
  setPersonalDocumentFoldersToRender: (folders) =>
    dispatch(acSetPersonalDocumentFoldersToRender(folders)),
  setPropertyDocumentFoldersToRender: (folders) =>
    dispatch(acSetPropertyDocumentFoldersToRender(folders)),
  setPersonalFoldersBreadCrumbs: (breadCrumbs) =>
    dispatch(acSetPersonalFoldersBreadCrumbs(breadCrumbs)),
  setPropertyFoldersBreadCrumbs: (breadCrumbs) =>
    dispatch(acSetPropertyFoldersBreadCrumbs(breadCrumbs)),
  deleteDocument: (document) => dispatch(acDeleteDocument(document)),
  setSearchText: (searchText) => dispatch(acSetDocumentSearchText(searchText)),
  deletePropertyDocumentFolder: (folder) =>
    dispatch(acDeletePropertyDocumentFolder(folder)),
  setIsCreatingDocumentFolder: (isCreatingDocumentFolder) =>
    dispatch(acSetIsCreatingDocumentFolder(isCreatingDocumentFolder)),
  setSelectedPersonalFolderId: (id) =>
    dispatch(acSetSelectedPersonalFolderId(id)),
  setSelectedPropertyFolderId: (id) =>
    dispatch(acSetSelectedPropertyFolderId(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Documents));
